var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AddCourierFreeDay.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-6482a86e!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddCourierFreeDay.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/AddCourierFreeDay.vue
// module id = 429
// module chunks = 1